import type { IconSvgObject } from './types';

const CropIcon: IconSvgObject = [
  ["path", { d: "M2.5 5H17C18.1046 5 19 5.89543 19 7V21.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 2.5V5M5 8.5V17C5 18.1046 5.89543 19 7 19H15M19 19H21.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default CropIcon;
